import { Button, Chip, Typography, useOpenable } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../../Translations';
import LCModal from '../../LCModal';
import CircleSparklesIcon from '../../../../components/Cutesies/CircleSparklesIcon';
import { trackIntercomEvent } from '../../../../services/intercomTrackingService';

function ChatbotPreviewAccess() {
  const { onOpen, isOpen, onClose } = useOpenable();

  const handleCreateCollection = () => {
    trackIntercomEvent('Home - Create a Collection');
    onOpen();
  };

  return (
    <>
      <Chip
        className="mt-10 flex flex-col h-auto p-6 gap-6 border border-dashed border-[#187a907a] 
        bg-homepage-ai-preview-button"
      >
        <div className="flex flex-row items-center gap-3 w-full">
          <CircleSparklesIcon />
          <Typography color="black" fontWeight="semibold" variant="bodyLarge">
            <T kind="Build a learning collection in minutes with AI" />
          </Typography>
        </div>
        <Typography as="div" variant="caption">
          <T
            kind="ExecOnline offers <span>{{name}}</span> to save you time and help you create collections that drive impact, fast."
            span={(name) => <span className="font-bold">{name}</span>}
            name="AI advisory"
          />
        </Typography>
        <Button
          className="py-2 px-3"
          onClick={handleCreateCollection}
          data-intercom-target="create-collection-with-ai"
          fullWidth
        >
          <T kind="Create a Collection" />
        </Button>
      </Chip>
      <LCModal isOpen={isOpen} onClose={onClose} />
    </>
  );
}

export default observer(ChatbotPreviewAccess);
